import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Variables } from '../variables';
import { Router } from '@angular/router';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements AfterViewInit {

    public personalNumber: number;
    public inputValid: boolean;
    public loading: boolean;
    public isMobil: boolean;

    ngAfterViewInit() {
    }

    constructor(public http: HttpClient, public variables: Variables, public router: Router) {
        this.loading = false;
    }

    public startAuthentication() {
        let scope = this;
        let redirect = 'null';

        redirect = this.variables.appSettings['RedirectURL']
            .replace('[LANG]', this.variables.language)
            .replace('[TOKEN]', this.variables.token);
        const language = this.variables.language;
        const databaseId = this.variables.token;

        const requestBody = { CallbackUri: redirect };
        const apiAuthUrl = this.variables.getAPIAuthURL() + "auth/initiate/bankid/";

        this.http.post<StartAuthentication>(apiAuthUrl, requestBody).subscribe(result => {
            var session = new AuthenticationSession();
            session.SessionID = result.sessionId;
            session.ExpireTime = Date.now() + 5 * 60 * 1000;

            localStorage.setItem('authSession', JSON.stringify(session));
            localStorage.setItem('l', JSON.stringify(language));
            localStorage.setItem('t', JSON.stringify(databaseId));
                      
            window.location.href = result.redirectUrl;

        }, () => {
            scope.loading = false;
            scope.variables.loginError = true;
            scope.router.navigate([''], { queryParams: { l: this.variables.language, t: this.variables.token } });
        });
    }
}

class StartAuthentication {
    AppStartToken: string;
    sessionId: string;
    redirectUrl: string;
    errorObject: any;
    Language: string;
    DatabaseId: string;
}

class AuthenticationSession {
    SessionID: string;
    ExpireTime: number;
}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts